import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../components/layout/DefaultConsumerLayout';

export default (
  <Route
    key="/consumer/appdownload/:defaultApp?"
    element={
      <DefaultConsumerLayout
        breadcrumb={[
          {
            position: 1,
            name: 'Home',
            item: '/',
          },
          {
            position: 2,
            name: 'Consumer',
            item: '/consumer',
          },
          {
            position: 3,
            name: 'App download',
            item: '/consumer/appdownload/ymk',
          },
        ]}
      />
    }
  >
    {/* FIXME(v6 migration): original path was optional multi-value enum
        ":defaultApp(ycn|ycp|ycv|ymk)?" which v6 does not support.
        Needs splitting into explicit routes (e.g. one per app + one bare). */}
    <Route path="consumer/appdownload/:defaultApp?" element={<AsyncPage />} />
  </Route>
);
